import React, { useState, useEffect } from "react";
import { Modal, Button, Col, Card } from "react-bootstrap";
import suggestionsData from "../../data/suggestions.json"; // Load data from the JSON file
import "../../styles/FirstDay.css"

const ItineraryUpdateModal = ({ show, onHide, dayNumber, onConfirm }) => {
  const [newItems, setNewItems] = useState([]);
  const [expandedCard, setExpandedCard] = useState(null);

  useEffect(() => {
    // Fetch `newitems` from the suggestions JSON based on dayNumber
    const items = suggestionsData.newitems || [];
    setNewItems(items);
  }, [dayNumber]);

  const toggleCard = (index) => {
    setExpandedCard(expandedCard === index ? null : index);
  };

  return (
    <Modal show={show} onHide={onHide} centered>
      <Modal.Header closeButton>
        <Modal.Title>Suggestions While You Wait</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        {newItems && newItems.length > 0 ? (
          newItems.map((item, index) => (
            <Col md={12} key={index} className="mb-4">
              <Card onClick={() => toggleCard(index)} className="custom-card">
                <Card.Body className="card-body-itinerary-item">
                  <img
                    src={item.image}
                    alt={item.title}
                    className="card-image"
                  />
                  <div style={{ textAlign: "left" }}>
                    <h5 className="card-title">{item.title}</h5>
                    <p className="card-details">
                      <span>🏛️ {item.category || "Points of Interest"}</span>
                      <br />
                      <span>
                        ⏱️ Duration:{" "}
                        <strong>{item.duration || "2 hours"}</strong>
                      </span>
                    </p>
                    {expandedCard === index ? (
                      <div
                        className="read-more-container"
                        onClick={() => toggleCard(null)}
                      >
                        <span className="read-more-text">Read less</span>
                        <span className="material-icons read-more-icon">
                          expand_less
                        </span>
                      </div>
                    ) : (
                      <div
                        className="read-more-container"
                        onClick={() => toggleCard(index)}
                      >
                        <span className="read-more-text">Read more</span>
                        <span className="material-icons read-more-icon">
                          expand_more
                        </span>
                      </div>
                    )}
                    {expandedCard === index && (
                      <p className="mt-2">{item.description}</p>
                    )}
                  </div>
                </Card.Body>
              </Card>
            </Col>
          ))
        ) : (
          <p>No items available</p>
        )}
      </Modal.Body>
      <Modal.Footer>
        <Button variant="primary" onClick={onConfirm}>
          Update Itinerary
        </Button>
        <Button variant="secondary" onClick={onHide}>
          Close
        </Button>
      </Modal.Footer>
    </Modal>
  );
};

export default ItineraryUpdateModal;
